import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Label,
  RadioGroup,
  RadioGroupItem,
} from '@accure/ui';

import { WorkstreamTemplatesQuery } from '@/project-management/queries/workstream-templates.query';

import {
  type AddWorkstreamModalOpen,
  useAddWorkstreamModal,
} from './add-workstream.provider';
import { AddWorkstreamCustomForm } from './create-workstream-custom.form';
import { AddWorkstreamTemplateForm } from './create-workstream-template.form';

export type AddWorkstreamModalProps = {
  formType: AddWorkstreamModalOpen;
  onClose: () => void;
};

export function AddWorkstreamModal({
  formType,
  onClose,
}: AddWorkstreamModalProps) {
  WorkstreamTemplatesQuery.useQuery();
  const addWorkstream = useAddWorkstreamModal();

  return (
    <Dialog open={Boolean(formType)} onOpenChange={onClose}>
      <DialogContent className="gap-6 sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Add New Workstream</DialogTitle>
          <p className="text-sm text-gray-600">
            Create a new workstream to group related tasks and enhance project
            visibility.
          </p>
        </DialogHeader>

        <RadioGroup
          value={formType}
          onValueChange={(value) =>
            addWorkstream(value as AddWorkstreamModalOpen)
          }
          className="flex flex-col gap-3"
        >
          <div className="flex items-center gap-2">
            <RadioGroupItem value="custom" id="custom" />
            <Label htmlFor="custom" className="font-medium">
              Create Custom Workstream
            </Label>
          </div>
          <div className="flex items-center gap-2">
            <RadioGroupItem value="template" id="template" />
            <Label htmlFor="template" className="font-medium">
              Use Predefined Template
            </Label>
          </div>
        </RadioGroup>

        {formType === 'custom' ? (
          <AddWorkstreamCustomForm onClose={onClose} />
        ) : formType === 'template' ? (
          <AddWorkstreamTemplateForm onClose={onClose} />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
